import React from 'react';
import CustomFieldContent from 'components/admin/manage/customField/CustomFieldContent';
// import CustomFieldContent from 'components/admin/manage/customField2/CustomFieldContent';

export const CustomFieldPage = () => {
  return <CustomFieldContent />;
};
